import React, { memo } from 'react';
import {
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';

import Search from '../../Search';
import Top from '../../Top';
import CardPage from '../../CardPage';

export default memo(({ path, base, tabs }) => {
  return (
    <Switch>
      {tabs.map(tab => {
        if (tab.contentType === '1') {
          return (
            <Route
              key={tab.code}
              exact
              path={`${path}/${tab.code}`}
              render={() => <CardPage code={tab.code} source={tab.source} />} />
          )
        }

        if (tab.contentType === '2') {
          return (
            <Route
              key={tab.code}
              exact
              path={`${path}/${tab.code}`}
              render={() => <Search source={tab.source} />} />
          );
        }

        if (tab.contentType === '3') {
          return (
            <Route
              key={tab.code}
              exact
              path={`${path}/${tab.code}/:code?`}
              render={() => <Top source={tab.source} />} />
          );
        }

        return null;
      })}
      <Redirect to={`${base}/${tabs[0].code}`} />
    </Switch>
  );
});
